/* 项目分组下 路由集合 */

import Layout from '@/layout'

// 题库
export const TikuRouters = {
  path: '/tiku',
  component: Layout,
  meta: {
    title: '题库',
    icon: 'book-open-line',
    alwaysShow: true,
  },
  redirect: '/tiku/index',
  children: [
    {
      path: 'exam_course_manage',
      name: 'tiku_exam_course_manage',
      component: () => import('@/views/project/tiku/examCourseManage/index'),
      hidden: true,
      meta: {
        title: '试卷课程管理',
        icon: '',
      },
    },
    {
      path: 'zhenti_manager',
      name: 'tiku_zhenti_manager',
      component: () => import('@/views/project/tiku/zhenti/index'),
      meta: {
        title: '真题管理',
        icon: '',
        tabName: {
          red_packet: '真题红包',
        },
      },
    },
    {
      path: 'question_check',
      name: 'tiku_question_check',
      component: () => import('@/views/project/tiku/questionCheck/index'),
      meta: {
        title: '题目校对',
        icon: '',
        tabName: {
          question_list: '题目校对',
          task_log: '任务日志',
          check_log: '校对日志',
          incorrect_words: '人工纠错词库',
        },
      },
    },
    {
      path: 'note_examine',
      name: 'tike_note_examine',
      component: () => import('@/views/project/tiku/noteExamine/index'),
      meta: {
        title: '笔记审核',
        icon: '',
      },
    },
    {
      path: 'error_manage',
      name: 'tiku_error_manage',
      component: () => import('@/views/project/tiku/errorManage/index'),
      meta: {
        title: '纠错管理',
        icon: '',
        tabName: {
          goods_error: '商品纠错',
        },
      },
    },
    {
      path: 'video_error',
      name: 'tiku_video_error',
      component: () => import('@/views/project/tiku/videoError/index'),
      meta: {
        title: '视频纠错审核',
        icon: '',
      },
    },
    {
      path: 'product_change',
      name: 'tiku_product_change',
      component: () => import('@/views/project/tiku/productChange/productList/index'),
      meta: {
        title: '产品信息总览',
        icon: '',
        tabName: {
          product_list: '产品信息总览',
        },
      },
    },
    {
      path: 'version_and_correct',
      name: 'tiku_version_and_correct',
      component: () => import('@/views/project/tiku/productChange/versionAndCorrect/index'),
      meta: {
        title: '版本与更新记录',
        icon: '',
        tabName: {
          version_manage: '产品版本管理',
          correct_log: '版本与更新记录',
        },
      },
    },
    {
      path: 'zhentiji_manager',
      name: 'tiku_zhentiji_manager',
      component: () => import('@/views/project/tiku/zhentiji/index'),
      meta: {
        title: '历年真题集',
        icon: '',
        tabName: {
          zhentiji_manage: '历年真题集',
          zhentijuan_manage: '真题卷',
        },
      },
    },
    {
      path: 'updateList',
      name: 'tiku_updateList',
      hidden: true,
      component: () => import('@/views/project/tiku/tikuModals/updateList/index'),
      meta: {
        title: '题库更新列表',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'book_question',
      name: 'tiku_book_question',
      hidden: true,
      component: () => import('@/views/project/tiku/bookManage/bookQuestion/index'),
      meta: {
        title: '待修改书籍题目列表',
        icon: '',
      },
    },
    {
      path: 'all_book_question',
      name: 'tiku_all__book_question',
      hidden: true,
      component: () => import('@/views/project/tiku/bookManage/allBookQuestion/index'),
      meta: {
        title: '总书籍题目列表',
        icon: '',
      },
    },
    {
      path: 'likely',
      name: 'tiku_likely',
      hidden: false,
      component: () => import('@/views/project/tiku/tikuLikely/index'),
      meta: {
        title: '题目相似度',
        icon: '',
      },
    },
    {
      path: 'zhenti_import',
      name: 'tiku_zhenti_import',
      hidden: false,
      component: () => import('@/views/project/tiku/zhentiImport/index'),
      meta: {
        title: '真题导入',
        icon: '',
      },
    },
    {
      path: 'zhenti_preview',
      name: 'tiku_zhenti_preview',
      hidden: false,
      component: () => import('@/views/project/tiku/zhentiPreview/index'),
      meta: {
        title: '真题预览',
        icon: '',
      },
    },
    {
      path: 'spider_similar',
      name: 'tiku_spider_similar',
      hidden: true,
      component: () => import('@/views/project/zhenti/spiderSimilar/index'),
      meta: {
        title: '真题估分相似题目列表',
        icon: '',
      },
    },
    {
      path: 'check_spide_task',
      name: 'tiku_check_spide_task',
      hidden: true,
      component: () => import('@/views/project/zhenti/checkSpideTask/index'),
      meta: { title: '真题收集任务审核', keepAlive: true },
    },
    {
      path: 'zhentiji_exam_see',
      name: 'tiku_zhentiji_exam_see',
      hidden: false,
      component: () => import('@/views/project/tiku/zhentijiExamSee/index'),
      meta: {
        title: '真题卷查看',
        icon: '',
      },
    },
    {
      path: 'version',
      name: 'tiku_version',
      component: () => import('@/views/project/tiku/versionManage/index'),
      meta: {
        title: '版本管理',
        icon: '',
      },
    },
    {
      path: 'update_timeline',
      name: 'tiku_update_timeline',
      component: () => import('@/views/project/tiku/updateTimeline/index'),
      meta: {
        title: '大纲更新流程指引',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'timeline_overview',
      name: 'tiku_timeline_overview',
      component: () => import('@/views/project/tiku/updateTimeline/overview'),
      meta: {
        title: '教研部工作流程指引首页',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'ocr_tasks',
      name: 'tiku_ocr_tasks',
      hidden: true,
      component: () => import('@/views/project/tiku/ocrTasks/index'),
      meta: {
        title: '批量导题任务列表',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'ocr_import',
      name: 'tiku_ocr_import',
      hidden: true,
      component: () => import('@/views/project/tiku/ocrImport/index'),
      meta: {
        title: '批量导题详情页',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'ocr_preview',
      name: 'tiku_ocr_preview',
      hidden: true,
      component: () => import('@/views/project/tiku/ocrPreview/index'),
      meta: {
        title: '批量导题预览页',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'error_coreection_stat',
      name: 'tiku_error_coreection_stat',
      component: () => import('@/views/project/tiku/errorCoreectionStat/index'),
      meta: {
        title: '题目错误统计',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'goods_book_create',
      name: 'tiku_goods_book_create',
      component: () => import('@/views/project/tiku/goodsBookCreate/index'),
      meta: {
        title: '考点生成',
        icon: '',
        hideMenu: false,
      },
    },
    {
      path: 'kaodian_check',
      name: 'tiku_kaodian_check',
      component: () => import('@/views/project/tiku/kaodianCheck/index'),
      meta: {
        title: '考点检查',
        icon: '',
        hideMenu: false,
      },
    },
    {
      path: 'goods_book_relevance',
      name: 'tiku_goods_book_relevance',
      component: () => import('@/views/project/tiku/goodsBookRelevance/index'),
      meta: {
        title: '考点关联',
        icon: '',
        hideMenu: false,
      },
    },
    {
      path: 'struct_tree',
      name: 'tiku_struct_tree',
      component: () => import('@/views/project/tiku/structTreeManage/index'),
      meta: {
        title: '科目章节列表',
        icon: '',
        hideMenu: true,
      },
    },
    {
      path: 'ai_verify/ai_verify_config',
      name: 'tiku_ai_verify_config',
      component: () => import('@/views/project/ai_verify/ai_verify_config/index'),
      meta: {
        title: 'AI批量验证-任务配置',
        icon: 'robot-line',
      },
    },
    {
      path: 'ai_verify/ai_verify_task_list',
      name: 'tiku_ai_verify_task_list',
      component: () => import('@/views/project/ai_verify/ai_verify_task_list/index'),
      meta: {
        title: 'AI批量验证-任务列表',
        icon: 'list-check',
      },
    },
    {
      path: 'ai_verify/ai_verify_task_detail',
      name: 'tiku_ai_verify_task_detail',
      component: () => import('@/views/project/ai_verify/ai_verify_task_detail/index'),
      meta: {
        title: 'AI批量验证-任务详情',
        icon: 'file-list-line',
      },
    },
    {
      path: 'zhenti-review',
      name: 'zhenti_review',
      component: () => import('@/views/project/zhenti/review/index'),
      hidden: true,
      meta: {
        title: '真题收集-精审',
        icon: '',
      },
    },
    {
      path: 'zhenti-yazhong',
      name: 'zhenti_yazhong',
      component: () => import('@/views/project/zhenti/yazhong/index'),
      hidden: true,
      meta: {
        title: '真题收集-押中',
        icon: '',
      },
    },
  ],
}
// 题目生成
export const questionProductionRouters = {
  path: '/question_production',
  component: Layout,
  meta: {
    title: '题目生成',
  },
  redirect: '/question_production/index',
  children: [
    {
      path: 'index',
      name: 'question_production_index',
      component: () => import('@/views/project/questionProduction/index'),
      meta: {
        title: '题目生成',
        icon: 'file-unknow-line',
        tabName: {
          task_list: '任务列表',
          mask_config: '面具配置',
        },
      },
    },
    {
      path: 'question_notes_select',
      name: 'question_production_question_notes_select',
      component: () => import('@/views/project/questionProduction/questionNotesSelect/index'),
      hidden: true,
      meta: {
        title: '知识点选择',
      },
    },
    {
      path: 'index_ai',
      name: 'question_production_index_ai',
      component: () => import('@/views/project/questionProduction/questionProductionAI/index'),
      meta: {
        title: 'AI题目生成',
      },
    },
    {
      path: 'question_supplement',
      name: 'question_production_question_supplement',
      component: () => import('@/views/project/questionProduction/questionSupplement/index'),
      meta: {
        title: '题目补充',
      },
    },
  ],
}

/* 积分/秒杀商城 路由集合 */
export const IntegralSeckillRouters = {
  path: '/integral_seckill',
  component: Layout,
  meta: {
    title: '积分/秒杀商城',
    icon: 'bank-card-fill',
  },
  alwaysShow: true,
  redirect: '/integral_seckill/manage_goods',
  children: [
    {
      path: 'manage_goods',
      name: 'integral_seckill_manage_goods',
      component: () => import('@/views/project/integralSeckill/manageGoods/index'),
      meta: {
        title: '商品管理',
        icon: '',
        tabName: {
          good_list: '商品管理',
          new_manage_inventory: '库存记录(子商品)',
          inventory_record: '进销存记录',
          subgood_manage: '子商品管理',
          supplier_manage: '供应商管理',
        },
      },
    },
    {
      path: 'integral_order',
      name: 'integral_seckill_integral_order',
      component: () => import('@/views/project/integralSeckill/manageOrder/index'),
      meta: {
        title: '积分商城订单',
        icon: '',
        tabName: {
          not_deliver: '积分商城-未发货订单',
          delivered: '积分商城-已发货订单',
          refund: '积分商城-退款订单',
          refund_goods: '积分商城-退货订单',
        },
      },
    },
    {
      path: 'seckill_order',
      name: 'integral_seckill_seckill_order',
      component: () => import('@/views/project/integralSeckill/manageOrder/index'),
      meta: {
        title: '秒杀商城订单',
        icon: '',
        tabName: {
          not_deliver: '秒杀商城-未发货订单',
          delivered: '秒杀商城-已发货订单',
          refund: '秒杀商城-退款订单',
          refund_goods: '秒杀商城-退货订单',
        },
      },
    },
    {
      path: 'manage_comment',
      name: 'integral_seckill_manage_comment',
      component: () => import('@/views/project/integralSeckill/manageComment/index'),
      meta: {
        title: '评价管理',
        icon: '',
      },
    },
    {
      path: 'integral_chart',
      name: 'integral_seckill_integral_chart',
      component: () => import('@/views/project/integralSeckill/statisticsChart/index'),
      hidden: true,
      meta: {
        title: '统计图表',
        icon: '',
      },
    },
    {
      path: 'integral_reimbursement',
      name: 'integral_seckill_integral_reimbursement',
      component: () => import('@/views/project/integralSeckill/reimbursement/index'),
      hidden: true,
      meta: {
        title: '报销单',
        icon: '',
        modalPage: true,
      },
    },
  ],
}

// 商城
export const shoppingMallRouters = {
  path: '/shoppingMall',
  component: Layout,
  meta: {
    title: '商城',
    icon: 'shopping-bag-line',
    alwaysShow: true,
  },
  redirect: '/shoppingMall',
  children: [
    {
      path: 'refundManage',
      name: 'refund_manage',
      component: () => import('@/views/project/shoppingMall/refundManage/index'),
      meta: {
        title: '退款管理',
        icon: '',
      },
    },
    {
      path: 'videosEdit',
      name: 'videosModals_videosEdit',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/videosModals/videosEdit/index'),
      meta: {
        title: '视频管理编辑弹层',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'questionList',
      name: 'videosModals_questionList',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/videosModals/questionList/index'),
      meta: {
        title: '视频题目列表弹层',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'groupWork',
      name: 'groupWork_orderList',
      component: () => import('@/views/project/shoppingMall/groupWork/index'),
      meta: {
        title: '拼团订单',
        icon: '',
      },
    },
    {
      path: 'shopTiku',
      name: 'shopTiku_orderList',
      component: () => import('@/views/project/shoppingMall/shopTiku/index'),
      meta: {
        title: '题库订单',
        icon: '',
        tabName: {
          paid_orders: '题库订单列表',
          refund_list: '题库退款列表',
        },
      },
    },
    {
      path: 'realProblem',
      name: 'realProblem_orderList',
      component: () => import('@/views/project/shoppingMall/realProblem/index'),
      meta: {
        title: '历年真题集订单',
        icon: '',
        tabName: {
          real_problem_list: '历年真题集订单列表',
          refund_list: '历年真题集退款订单列表',
        },
      },
    },
    {
      path: 'electronicOrder',
      name: 'electronicOrder_orderList',
      component: () => import('@/views/project/shoppingMall/electronicOrder/index'),
      meta: {
        title: '电子试卷订单',
        icon: '',
        tabName: {
          electronic_order_list: '电子试卷订单列表',
          refund_list: '电子试卷退款订单列表',
        },
      },
    },
    {
      path: 'examinationOrder',
      name: 'examination_order',
      component: () => import('@/views/project/shoppingMall/examinationOrder/index'),
      meta: {
        title: '考点订单',
        icon: '',
      },
    },
    {
      path: 'courseManage',
      name: 'course_manage',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/courseManage/index'),
      meta: {
        title: '课程管理',
        icon: '',
      },
    },
    {
      path: 'batchUpload',
      name: 'batch_upload',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/batchUpload/index'),
      meta: {
        title: '批量添加',
        icon: '',
      },
    },
    {
      path: 'pushModal',
      name: 'shoppingMall_pushModal',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/pushModal/index'),
      meta: {
        title: 'push消息弹窗',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'examDelay',
      name: 'exam_delay',
      component: () => import('@/views/project/shoppingMall/examDelay/index'),
      meta: {
        title: '考试延期订单',
        icon: '',
        tabName: {
          order_manage: '考试延期订单管理',
          goods_manage: '考试商品延期管理',
        },
      },
    },
    {
      path: 'goodsLive',
      name: 'shop_goodsLive',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/shopModals/goodsLive/index'),
      meta: {
        title: '商品讲解视频上传',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'goodsAgent',
      name: 'goods_agent',
      component: () => import('@/views/project/shoppingMall/goodsAgent/index'),
      meta: {
        title: '实体商品代理',
        icon: '',
      },
    },
    {
      path: 'commentManage',
      name: 'comment_manage',
      component: () => import('@/views/project/shoppingMall/commentManage/tabIndex'),
      meta: {
        title: '评价管理',
        icon: '',
      },
    },
    {
      path: 'invoiceManage',
      name: 'invoice_manage',
      component: () => import('@/views/project/shoppingMall/invoiceManage/index'),
      meta: {
        title: '发票管理',
        icon: '',
      },
    },
    {
      path: 'transferExam',
      name: 'shoppingMall_transferExam',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/shopModals/transferExam/index'),
      meta: {
        title: '转考试弹窗',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'teacherManage',
      name: 'videosModals_teacherManage',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/videosModals/teacherManage/index'),
      meta: {
        title: '讲师管理',
        icon: '',
        modalPage: true,
      },
    },
    {
      path: 'homePageGoodsManage',
      name: 'shopModals_homePageGoodsManage',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/shopModals/homePageGoodsManage/index'),
      meta: {
        title: '首页商品展示管理',
        icon: '',
        // modalPage: true,
      },
    },
    {
      path: 'goodsErrorCorrect',
      name: 'goods_error_correct',
      hidden: true,
      component: () => import('@/views/project/shoppingMall/goodsErrorCorrect/index'),
      meta: {
        title: '用户勘误处理',
        icon: '',
        modalPage: true,
      },
    },
  ],
}
// 易错考点
export const fallibilityPointRouters = {
  path: '/fallibilityPoint',
  component: Layout,
  meta: {
    title: '易错考点',
    icon: 'shopping-bag-line',
    alwaysShow: true,
  },
  redirect: '/fallibilityPoint',
  children: [
    {
      path: 'manageOrder',
      name: 'manageOrder_orderList',
      component: () => import('@/views/project/fallibilityPoint/manageOrder/index'),
      meta: {
        title: '订单管理',
        icon: '',
        tabName: {
          fallibility_list: '易错考点订单列表',
          refund_list: '易错考点退款订单列表',
        },
      },
    },
  ],
}

// 直播
export const liveManageRouters = {
  path: '/live_manage',
  component: Layout,
  meta: {
    title: '直播管理',
    icon: 'live-line',
  },
  redirect: '/live_manage/index',
  children: [
    {
      path: 'index',
      name: 'live_manage_index',
      component: () => import('@/views/project/liveManage/index'),
      meta: {
        title: '直播管理',
        icon: 'live-line',
      },
    },
    {
      path: 'statistics/:id/:name/:type',
      name: 'live_manage_statistics',
      component: () => import('@/views/project/liveManage/statistics'),
      hidden: true,
      meta: {
        title: '直播数据',
        icon: '',
        setBreadcrumb: true,
      },
    },
  ],
}

export const scheduleRouters = {
  path: '/schedule',
  component: Layout,
  meta: {
    title: '小护排班',
    icon: 'calendar-todo-line',
    alwaysShow: true,
  },
  redirect: '/schedule/help',
  children: [
    {
      path: 'help',
      name: 'schedule_help',
      component: () => import('@/views/project/schedule/scheduleHelp/index'),
      meta: {
        title: '帮助与反馈',
        icon: 'question-line',
      },
    },
  ],
}

export const hiringManageRouters = {
  path: '/hiring_manage',
  component: Layout,
  meta: {
    title: '招聘管理',
    icon: 'hospital-line',
    alwaysShow: true,
  },
  redirect: '/hiring_manage/hospital_audit',
  children: [
    {
      path: 'hospital_audit',
      name: 'hiring_manage_hospital_audit',
      component: () => import('@/views/project/hiringManage/hospitalAudit/index'),
      meta: {
        title: '医院审核页',
        icon: '',
      },
    },
    {
      path: 'default_role_setting',
      name: 'hiring_manage_default_role_setting',
      component: () => import('@/views/project/hiringManage/defaultRoleSetting/index'),
      meta: {
        title: '默认角色配置',
        icon: '',
      },
    },
    {
      path: 'permission_setting',
      name: 'hiring_manage_permission_setting',
      component: () => import('@/views/project/hiringManage/permissionSetting/index'),
      meta: {
        title: '权限配置',
        icon: '',
      },
    },
  ],
}

// 微课
export const coursesRouters = {
  path: '/courses',
  component: Layout,
  meta: {
    title: '微课',
    icon: 'article-line',
  },
  redirect: '/courses',
  children: [
    {
      path: 'manage_video',
      name: 'video_manage',
      component: () => import('@/views/project/cources/videoManage/index'),
      meta: {
        title: '临床课程管理',
        icon: 'article-line',
      },
    },
    {
      path: 'teacher_help',
      name: 'help_center',
      component: () => import('@/views/project/cources/teacherUpLoad/helpPage'),
      meta: {
        title: '帮助中心',
        icon: 'article-line',
      },
    },
    {
      path: 'teacher_cources',
      name: 'cources_center',
      component: () => import('@/views/project/cources/teacherUpLoad/videoManage/index'),
      meta: {
        title: '课程目录',
        icon: 'article-line',
      },
    },
  ],
}

export const caseManageRouters = {
  path: '/case_manage',
  component: Layout,
  meta: {
    title: '病例管理',
    icon: '',
  },
  redirect: '/case_manage/index',
  children: [
    {
      path: 'index',
      name: 'case_manage_index',
      component: () => import('@/views/project/caseManage/index'),
      meta: {
        title: '病例管理',
        icon: 'newspaper-line',
      },
    },
  ],
}

// 押密
export const YamiRouters = {
  path: '/yami',
  component: Layout,
  meta: {
    title: '押密',
    icon: 'boxing-line',
    alwaysShow: true,
  },
  redirect: '/tiku/index',
  children: [
    {
      path: 'goods_list',
      name: 'yami_goods_list',
      hidden: false,
      component: () => import('@/views/project/yami/goodsList/index'),
      meta: {
        title: '押密列表',
        icon: '',
      },
    },
    {
      path: 'kaodian_edit',
      name: 'yami_kaodian_edit',
      hidden: true,
      component: () => import('@/views/project/yami/yamiList/kaodianEdit/index'),
      meta: {
        title: '考点选择',
        icon: '',
      },
    },
    {
      path: 'presell_trade',
      name: 'yami_presell_trade',
      hidden: false,
      component: () => import('@/views/project/yami/orderList/index'),
      meta: {
        title: '押密订单',
        icon: '',
      },
    },
    {
      path: 'refund',
      name: 'yami_refund',
      component: () => import('@/views/project/yami/refundList/index'),
      meta: {
        title: '不过包退',
        icon: '',
      },
    },
    {
      path: 'statistics',
      name: 'yami_statistics',
      component: () => import('@/views/project/yami/statistics/index'),
      meta: {
        title: '数据统计',
        icon: '',
      },
    },
    {
      path: 'comparison_modal',
      name: 'yami_comparison_modal',
      hidden: true,
      component: () => import('@/views/project/yami/yamiList/comparisonModal/index'),
      meta: {
        title: '条目重复率查询结果',
        icon: '',
        modalPage: true,
      },
    },
  ],
}

// 资料
export const ZiliaoRouters = {
  path: '/ziliao',
  component: Layout,
  meta: {
    title: '资料',
    icon: 'article-line',
  },
  redirect: '/ziliao/ziliao_share_img',
  children: [
    {
      path: 'ziliao_list',
      name: 'zliao_ziliao_list',
      component: () => import('@/views/project/ziliao/ziliaoManage/index'),
      meta: {
        title: '资料',
        icon: 'article-line',
        tabName: {
          ziliao_list: '资料列表',
          share_img: '分享图管理',
        },
      },
    },
    {
      path: 'ziliao_share_img',
      name: 'ziliao_share_img',
      component: () => import('@/views/project/ziliao/ziliaoManage/components/ShareImg/index'),
      meta: {
        title: '资料',
        icon: 'article-line',
        tabName: {
          ziliao_list: '资料列表',
          share_img: '分享图管理',
        },
      },
    },
  ],
}
// 试卷管理
export const examManageRouters = {
  path: '/exam_manage',
  component: Layout,
  meta: {
    title: '试卷管理',
    icon: 'article-line',
  },
  redirect: '/exam_manage/exam_list',
  children: [
    {
      path: 'exam_list',
      name: 'exam_manage_list',
      component: () => import('@/views/project/examManage/index'),
      meta: {
        title: '模拟卷',
        icon: 'article-line',
        tabName: {
          ziliao_list: '模拟卷',
          icon: '',
        },
      },
    },
    {
      path: 'exam_see',
      name: 'exam_paper_see',
      component: () => import('@/views/project/examManage/recordExam'),
      meta: {
        title: '查看试卷（新版）',
        icon: '',
      },
      hidden: true,
    },
    {
      path: 'exam_see_old',
      name: 'exam_paper_see_old',
      component: () => import('@/views/project/examManage/recordExamOld'),
      meta: {
        title: '查看试卷(旧版)',
        icon: '',
      },
      hidden: true,
    },
    {
      path: 'exam_select_que',
      name: 'exam_paperselect_que',
      component: () => import('@/views/project/examManage/selectQue'),
      meta: {
        title: '试卷取题',
        icon: '',
      },
      // hidden: true,
    },
  ],
}
// 冲刺题库
export const ChongciRouters = {
  path: '/chongci',
  component: Layout,
  meta: {
    title: '冲刺题库',
    icon: 'boxing-line',
    alwaysShow: true,
  },
  redirect: '/chongci/chongci_list',
  children: [
    {
      path: 'chongci_list',
      name: 'chongci_chongci_list',
      hidden: false,
      component: () => import('@/views/project/chongci/chongciManage/index'),
      meta: {
        title: '题库管理',
        icon: '',
      },
    },
    {
      path: 'chongci_order_list',
      name: 'chongci_order_list',
      hidden: false,
      component: () => import('@/views/project/chongci/orderList/index'),
      meta: {
        title: '订单管理',
        icon: '',
      },
    },
  ],
}
// 目录生成
export const bookCatalogRouters = {
  path: '/book_catalog',
  component: Layout,
  meta: {
    title: '书籍目录',
    icon: 'boxing-line',
    alwaysShow: true,
  },
  redirect: '/book_catalog/catalog_select',
  children: [
    {
      path: 'catalog_select',
      name: 'book_catalog_select',
      hidden: false,
      component: () => import('@/views/project/bookCatalog/catalogSelect/index'),
      meta: {
        title: '目录选择',
        icon: '',
      },
    },
    {
      path: 'catalog_edit',
      name: 'book_catalog_edit',
      hidden: false,
      component: () => import('@/views/project/bookCatalog/catalogEdit/index'),
      meta: {
        title: '目录编辑',
        icon: '',
      },
    },
    {
      path: 'catalog_relevance',
      name: 'book_catalog_relevance',
      hidden: false,
      component: () => import('@/views/project/bookCatalog/catalogRelevance/index'),
      meta: {
        title: '目录关联',
        icon: '',
      },
    },
  ],
}
// 书籍管理
export const bookManageRouters = {
  path: '/book_manege',
  component: Layout,
  meta: {
    title: '书籍管理',
    icon: 'boxing-line',
  },
  redirect: '/book_manege/book_list',
  children: [
    {
      path: 'book_list',
      name: 'book_manege_list',
      component: () => import('@/views/project/bookManege/bookList/index'),
      meta: {
        title: '书籍列表',
        icon: 'article-line',
      },
    },
    {
      path: 'book_dir_ai_relate',
      name: 'book_dir_ai_relate',
      component: () => import('@/views/project/bookDirAiRelate/index'),
      meta: {
        title: 'AI目录关联',
        icon: 'node-tree',
      },
    },
  ],
}
export const bookGenerationRouters = {
  path: '/book_generation',
  component: Layout,
  meta: {
    title: '书籍生成',
    icon: 'boxing-line',
    alwaysShow: true,
  },
  redirect: '/book_generation/generation_check',
  children: [
    {
      path: 'generation_check',
      name: 'book_generation_check',
      hidden: false,
      component: () => import('@/views/project/bookGeneration/generationCheck/index'),
      meta: {
        title: '书籍校对',
        icon: '',
      },
    },
    {
      path: 'generation_relevance',
      name: 'book_generation_relevance',
      hidden: false,
      component: () => import('@/views/project/bookGeneration/generationRelevance/index'),
      meta: {
        title: '书籍关联',
        icon: '',
      },
    },
  ],
}

//公共页面路由
export const componentsRouters = {
  path: '',
  component: Layout,
  meta: {
    title: '公共页面路由',
    icon: 'boxing-line',
    alwaysShow: false,
  },
  children: [
    {
      path: 'replace_question',
      name: 'ehf_replace_question',
      hidden: true,
      component: () => import('@/components/ehf-replace-question/index'),
      meta: {
        title: '替换题目',
        icon: '',
      },
    },
  ],
}
